// extracted by mini-css-extract-plugin
export default {"toastContainer":"styles_toastContainer__0lcs2","toast":"styles_toast__XOylf","body":"styles_body__wWyDH","head":"styles_head__gshhG","closeIcon":"styles_closeIcon__CkwWF"};